import { render, staticRenderFns } from "./LmMenuBuilderListbuilder.vue?vue&type=template&id=aae91d28&"
import script from "./LmMenuBuilderListbuilder.vue?vue&type=script&lang=js&"
export * from "./LmMenuBuilderListbuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports